module.exports = __webpack_public_path__ + "img/logo.75406ad4.png";